import { render, staticRenderFns } from "./mc-receive.vue?vue&type=template&id=2037f3ad&scoped=true"
import script from "./mc-receive.vue?vue&type=script&lang=ts"
export * from "./mc-receive.vue?vue&type=script&lang=ts"
import style0 from "./mc-receive.vue?vue&type=style&index=0&id=2037f3ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037f3ad",
  null
  
)

export default component.exports